import { Card, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';

import {
  BeneficiaryInvitationContextProvider,
  useBeneficiaryInvitationContext,
  type IBeneficiaryInvitationMode,
} from '../model';

import InvitationDetails from './InvitationDetails';
import InvitationFormCard from './InvitationFormCard';

const descriptions: Record<IBeneficiaryInvitationMode, string | null> = {
  pick: "Select the organization that will be named as beneficiary in the escrow agreement. If it isn't listed, add it and enter its registered name and address.",
  form: "Enter the beneficiary's name and primary contact. They'll be invited to confirm these details themselves.",
  view: null,
};

const InvitationCardBody = () => {
  const { escrowInvitation, mode } = useBeneficiaryInvitationContext();

  if (escrowInvitation && mode === 'view') return <InvitationDetails escrowInvitation={escrowInvitation} />;

  return <InvitationFormCard />;
};

const InvitationCard = () => {
  const { mode } = useBeneficiaryInvitationContext();
  const description = descriptions[mode];

  return (
    <Card>
      <CardHeader>
        <CardTitle>Beneficiary organization & primary contact</CardTitle>
        {description && <CardDescription>{description}</CardDescription>}
      </CardHeader>
      <InvitationCardBody />
    </Card>
  );
};

type Props = {
  escrowId: string;
  invitationId: string | null;
};

const BeneficiaryInvitation = ({ escrowId, invitationId }: Props) => {
  return (
    <BeneficiaryInvitationContextProvider escrowId={escrowId} invitationId={invitationId}>
      <InvitationCard />
    </BeneficiaryInvitationContextProvider>
  );
};

export default BeneficiaryInvitation;
